import React from 'react'
import TestComponent from "../components/testComponent.jsx";
//import component

function TestPage(){
    return (<TestComponent />)
}

export default TestPage
